// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1NS-R","label":"LabeledBox_label__2eT-3"};